






























import { defineComponent, ref, PropType } from '@vue/composition-api';
import { RightArrowOutline12 } from '@hb/coffee-icons';
import { LoanUsageOption } from '@/api/apply-product/types';
import OtherInfoPopup from './pop.vue';

// static component
// [功能说明]: 其他信息展示组件
interface Props {
  label?: string;
  institutionName?: string;
  loanPurposeOptions?: LoanUsageOption[];
  selectedLoanPurpose?: LoanUsageOption;
  containerHeight?: number;
  capitalCode?: string;
  productId?: string;
  rightLightUncreditedProduct?: {
    productId: string;
    productName: string;
  };
}

export default defineComponent({
  name: 'OtherInfo',
  components: {
    RightArrowOutline12,
    OtherInfoPopup,
  },
  props: {
    label: {
      type: String,
      default: '其他信息',
    },
    institutionName: {
      type: String,
      default: '马上消金',
    },
    loanPurposeOptions: {
      type: Array as PropType<LoanUsageOption[]>,
      default: () => [],
    },
    selectedLoanPurpose: {
      type: Object as PropType<LoanUsageOption>,
      default: () => ({
        name: '购物消费',
        code: 'shopping',
        available: true,
        sort: 0,
      }),
    },
    containerHeight: {
      type: Number,
      default: 0,
    },
    capitalCode: {
      type: String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
    rightLightUncreditedProduct: {
      type: Object as PropType<{
        productId: string;
        productName: string;
      }>,
    },
  },
  emits: ['update:selected-loan-purpose'],
  setup(props: Props, { emit }) {
    // 弹窗显示状态
    const showPopup = ref(false);

    // 处理点击事件
    const handleClick = () => {
      showPopup.value = true;
    };

    // 处理关闭弹窗
    const handleClosePopup = () => {
      showPopup.value = false;
    };

    // 处理借款用途更新
    const handleLoanPurposeUpdate = (purpose: LoanUsageOption) => {
      emit('update:selected-loan-purpose', purpose);
    };

    return {
      showPopup,
      handleClick,
      handleClosePopup,
      handleLoanPurposeUpdate,
      containerHeight: props.containerHeight,
      capitalCode: props.capitalCode,
      productId: props.productId,
      institutionName: props.institutionName,
      loanPurposeOptions: props.loanPurposeOptions,
      selectedLoanPurpose: props.selectedLoanPurpose,
    };
  },
});
